<!-- Laptop screen -->
@if (currentParent && currentParent.children) {
  <div
    class="sub-menu-container bg-white border-b border-b-[#e5e7eb] dark:border-b-[#242424]
           p-2 flex items-center gap-5 shadow-md dark:bg-[#1e293b] dark:text-white
           desktop-submenu">
    <nav class="flex items-center gap-5">
      @for (child of currentParent.children; track child.route) {
        @if (child.roles && child.roles.includes(role)) {
          <a
            class="sub-menu-item text-[#666] dark:text-white
                   hover:bg-[#d9e3f5] dark:hover:bg-[#1a305f]"
            routerLinkActive="active"
            [routerLink]="child.route"
            [queryParamsHandling]="child.queryParamsHandling"
            [routerLinkActiveOptions]="{ exact: false }">
            {{ child.label }}
          </a>
        }
      }
    </nav>
  </div>
}

<!-- Mobile screen -->
<p-accordion
  [value]="accordionValue"
  class="w-full mobile-submenu"
  (valueChange)="onAccordionSelection($event)">
  <p-accordion-panel value="0">
    <p-accordion-header>{{ selectedSubmenu }}</p-accordion-header>
    <p-accordion-content>
      @for (child of currentParent?.children ?? []; track child.route) {
        @if (child.roles && child.roles.includes(role)) {
          <a
            class="flex item hover:bg-gray-100 hover:dark:bg-gray-800"
            routerLinkActive="active"
            [routerLink]="child.route"
            [queryParamsHandling]="child.queryParamsHandling"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="onSelection(child.label)">
            {{ child.label }}
          </a>
        }
      }
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>